import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import {DEFAULT_LANGUAGE, PUBLIC_URL} from './config';


const isDev = process.env.NODE_ENV === 'development';

i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    //.use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: DEFAULT_LANGUAGE,
        debug: isDev,
        backend: {
            loadPath: PUBLIC_URL + 'locales/{{lng}}/translation.json',
            requestOptions: {
                cache: 'no-cache' // This will set the Cache-Control header to 'no-store'
            }
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            format: (value, format) => {
                if (format === 'capitalize') return value.charAt(0).toUpperCase() + value.slice(1);
                return value;
            },
        },
        returnNull: false,       // avoids rendering null
        returnEmptyString: false,
    });

export default i18n;
